import { render, staticRenderFns } from "./PurchaseLicense.vue?vue&type=template&id=023e1b6e"
import script from "./PurchaseLicense.vue?vue&type=script&lang=js"
export * from "./PurchaseLicense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports